module.exports = __webpack_public_path__ + "static/media/4.eff3e990.png";